module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_chapel_2-99e479ebee4572f0407432cc030709ab.jpg";